import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Popout" */ './lazyIndex'),
    { name: 'Popout' }
);

export const lazyBootPopout: LazyImport<typeof lazyIndex.bootPopout, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.bootPopout);
export const lazyClosePopout: LazyAction<typeof lazyIndex.closePopout, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.closePopout);
export const lazyWaitForProjectionUpdate: LazyImport<
    typeof lazyIndex.waitForProjectionUpdate,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.waitForProjectionUpdate);
export type { DeeplinkPopoutData } from './store/schema/PopoutData';
export type { default as PopoutData } from './store/schema/PopoutData';
export { default as addPopoutV2 } from './actions/addPopoutV2';
export { default as setPopoutChildState } from './actions/setPopoutChildState';
export { default as PopoutLoadingView } from './components/PopoutLoadingView';
export { PopoutChildState } from './store/schema/PopoutChildStore';
export { ProjectionItem } from './store/schema/PopoutParentStore';
export { getStore } from './store/childStore';
export { default as getDataFromParentWindow } from './utils/getDataFromParentWindow';
export { getReadingPaneRouteForPopoutV2 } from './utils/getReadingPaneRouteForPopoutV2';
export { getMailReadingPaneDeeplinkUrl } from './utils/getMailReadingPaneDeeplinkUrl';
export { default as isPopout } from './utils/isPopout';
export { default as getProjectionViewState } from './selectors/getProjectionViewState';
export { default as PopoutType } from './store/schema/PopoutType';
export { default as getProjection } from './utils/getProjection';
